import { useEffect, useRef, useState } from "react";
import { motion, useInView } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({
  children,
  delay = 0,
  y = 28,
  className = "",
  as = "div",
  ...rest
}) => {
  const Tag = motion[as] || motion.div;
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-70px" });
  const [fallback, setFallback] = useState(false);

  // Fail-safe: if the in-view trigger has not fired within ~500ms (client-side
  // navigation, restored scroll position, already-visible content), show the
  // content anyway — a reveal must never leave a section blank.
  useEffect(() => {
    if (inView) return;
    const t = setTimeout(() => setFallback(true), 500);
    return () => clearTimeout(t);
  }, [inView]);

  const show = inView || fallback;

  return (
    <Tag
      ref={ref}
      initial={{ opacity: 0, y }}
      animate={show ? { opacity: 1, y: 0 } : { opacity: 0, y }}
      transition={{ duration: 0.85, ease: EASE, delay: fallback && !inView ? 0 : delay }}
      className={className}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export const Eyebrow = ({ children, light = false }) => (
  <p
    className={`font-sans uppercase tracking-[0.22em] text-xs font-medium flex items-center gap-3 ${
      light ? "text-champagne" : "text-gold"
    }`}
  >
    <span className="inline-block h-px w-8 bg-gold" aria-hidden="true" />
    {children}
  </p>
);
